export default "__VITE_ASSET__c402528b__"